<template>
  <WebhookForm :id="id" :initial="effectiveInitial" :visibility-config="visibilityConfig" @saved="$emit('saved')">
    <template #parameters="{ getSecret, setSecret, getParam, setParam }">
      <div class="box">
        <h2 class="subtitle">{{ $t('anthropic.settings') }}</h2>

        <BFieldHint :label="$t('anthropic.model')" hintKey="">
          <b-input
            :model-value="getParam('MODEL')"
            :placeholder="$t('anthropic.modelPlaceholder')"
            @update:model-value="val => setParam('MODEL', val)"
          />
        </BFieldHint>

        <BFieldHint :label="$t('anthropic.system')" hintKey="">
          <b-input
            type="textarea"
            :rows="3"
            :model-value="getParam('SYSTEM')"
            :placeholder="$t('anthropic.systemPlaceholder')"
            @update:model-value="val => setParam('SYSTEM', val)"
          />
        </BFieldHint>

        <BFieldHint :label="$t('anthropic.maxTokens')" hintKey="">
          <b-input
            type="number"
            min="1"
            :model-value="getParam('MAX_TOKENS')"
            :placeholder="$t('anthropic.maxTokensPlaceholder')"
            @update:model-value="val => setParam('MAX_TOKENS', String(val))"
          />
        </BFieldHint>

        <BFieldHint :label="$t('anthropic.apiKey')" hintKey="">
          <b-select :model-value="getSecret('ANTHROPIC_API_KEY')"
                    :placeholder="$t('anthropic.selectSecret')"
                    @update:model-value="val => setSecret('ANTHROPIC_API_KEY', String(val))">
            <option v-for="name in secretOptions" :key="name" :value="name">{{ name }}</option>
          </b-select>
        </BFieldHint>
      </div>
    </template>
  </WebhookForm>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import WebhookForm from '@/views/templates/WebhookForm.vue'
import BFieldHint from '@/components/BFieldHint.vue'
import { useStore } from 'vuex'

type Param = { template_name: string; value: string }

export default defineComponent({
  name: 'AnthropicForm',
  components: { WebhookForm, BFieldHint },
  props: {
    id: String,
    initial: Object as PropType<Record<string, unknown>>
  },
  emits: ['saved'],
  setup(props) {
    const store = useStore()
    const secretOptions = computed<string[]>(() => {
      const s: any = store.state.secrets || []
      const list = Array.isArray(s) ? s : Object.values(s)
      return list.map((x: any) => String(x.name)).filter(Boolean)
    })

    const defaultInitial = {
      name: '',
      event: 'claude',
      parameters: [
        { template_name: 'MODEL', value: 'claude-3-opus-latest' },
        { template_name: 'SYSTEM', value: 'You are helpful assistant' },
        { template_name: 'MAX_TOKENS', value: '30' }
      ],
      template: 'anthropic-chat',
      url: 'https://api.anthropic.com/v1/messages',
      requestType: 'POST',
      noDefaults: true,
      rejectUnauthorized: true,
      responseTemplate: '{{{content.0.text}}}',
      unchunked: true,
      data_url_response_event: false,
      headers: {
        'anthropic-version': '2023-06-01',
        'x-api-key': '{{{ANTHROPIC_API_KEY}}}'
      },
      json: {
        model: '{{{MODEL}}}',
        messages: [ { role: 'user', content: '{{{FERMION_EVENT_VALUE}}}' } ],
        system: '{{{SYSTEM}}}',
        max_tokens: '{{{MAX_TOKENS}}}'
      }
    } as Record<string, unknown>

    const effectiveInitial = computed<Record<string, unknown>>(() => {
      return (props.initial as any) || defaultInitial
    })
    
    const visibilityConfig = {
      jsonTab: false,
      secrets: false,
      requestURL: false,
      requestType: false,
      requestFormat: true,
      requestFormatForm: false,
      requestFormatCustom: false,
      requestFormatJsonDefault: false,
      queryParams: false,
      httpHeaders: false,
      httpBasicAuth: false,
      responseTemplate: false
    }
    
    return { secretOptions, effectiveInitial, visibilityConfig }
  }
})
</script>
